import client from "./client.js";

/**
 * @param {String} FromDate
 * @param {String} ToDate
 * @returns {Promise}
 */
export function retrieveDataFromFirebird(FromDate, ToDate) {
  const params = new URLSearchParams();
  params.append("FromDate", FromDate);
  params.append("ToDate", ToDate);

  const config = {
    headers: {
      Authorization: "bearer " + localStorage.jwt,
    },
  };

  return client.post("salesdashboard/sale_datas/", params, config);
}
